import { useTracker } from '~/features/clickstream-sdk/composables/useTracker';
import { ETrackerActions } from '~/features/clickstream-sdk/ClickStreamTracker';
import { ETrackerPages } from '~/features/clickstream-sdk/models/pages';

export function useProductTracker() {
  const { track } = useTracker({ page: ETrackerPages.PRODUCT });

  /** Добавление товара в корзину
   * market_productScreen_toCart_click
   */
  const trackProductToCartClick = (
    productId: string,
    skuId: string,
    additionalParams?: {
      product_parameters?: any;
      product_parameters_list?: any;
      rating_value?: number;
      source?: string;
      is_picture_list?: boolean[];
      old_price?: number;
      price?: number;
      rev_num?: number;
      wishlist_toggle?: boolean;
      badges?: string;
      shop_id?: number;
      is_parsing_rating?: boolean;
      badges_id?: string;
      clickable_badges?: boolean;
    }
  ) =>
    track({
      element: 'toCart',
      action: ETrackerActions.CLICK,

      product_id: productId,
      sku_id: skuId,

      // Additional parameters from analytics requirements
      ...additionalParams,
    });

  /** Уменьшение количества товара в корзине
   * market_productScreen_reduceItemCount_click
   */
  const trackProductReduceItemCount = (
    productId: string,
    skuId: string,
    additionalParams?: {
      product_parameters?: any;
      product_parameters_list?: any;
      rating_value?: number;
      source?: string;
      is_picture_list?: boolean[];
      old_price?: number;
      price?: number;
      rev_num?: number;
      wishlist_toggle?: boolean;
      badges?: string;
      shop_id?: number;
      is_parsing_rating?: boolean;
      badges_id?: string;
      clickable_badges?: boolean;
    }
  ) =>
    track({
      block: 'unknown',
      element: 'reduceItemCount',
      action: ETrackerActions.CLICK,

      product_id: productId,
      sku_id: skuId,

      // Additional parameters from analytics requirements
      ...additionalParams,
    });

  /** Добавление товара в избранное
   * market_productScreen_favoritesAdd_click
   * TODO: Возможно, должен быть перенесен в отдельную фичу "Tracking Favorites"
   * См. задачу: https://track.magnit.ru/browse/B2CFRONT-6698
   */
  const trackProductToFavoritesAdd = (productId: string, skuId: string) =>
    track({
      block: 'favoritesAdd',
      action: ETrackerActions.CLICK,

      product_id: productId,
      sku_id: skuId,
    });

  /** Удаление товара из избранного
   * market_productScreen_favoritesDelete_click
   * TODO: Возможно, должен быть перенесен в отдельную фичу "Tracking Favorites"
   * См. задачу: https://track.magnit.ru/browse/B2CFRONT-6698
   */
  const trackProductToFavoritesDelete = (productId: string, skuId: string) =>
    track({
      block: 'favoritesDelete',
      action: ETrackerActions.CLICK,

      product_id: productId,
      sku_id: skuId,
    });

  /** Добавление товара в корзину из мини-карточки
   * market_miniProductScreen_toCart_click
   */
  const trackMiniProductToCartClick = (
    productId: string,
    skuId: string,
    additionalParams?: {
      product_parameters?: any;
      product_parameters_list?: any;
      rating_value?: number;
      source?: string;
      referer?: string;
      plid?: number | string;
      is_picture_list?: boolean[];
      old_price?: number;
      price?: number;
      rev_num?: number;
      wishlist_toggle?: boolean;
      badges?: string;
      shop_id?: number;
      is_parsing_rating?: boolean;
      badges_id?: string;
      clickable_badges?: boolean;
    }
  ) => {
    // Use a different page context for mini products
    const { track: miniTrack } = useTracker({ page: 'miniProductScreen' as any });
    return miniTrack({
      element: 'toCart',
      action: ETrackerActions.CLICK,

      product_id: productId,
      sku_id: skuId,

      // Additional parameters from analytics requirements
      ...additionalParams,
    });
  };

  /** Просмотр товара
   * market_productScreen_view
   */
  const trackProductView = (productId: string, skuId: string) =>
    track({
      action: ETrackerActions.VIEW,

      product_id: productId,
      sku_id: skuId,
    });

  return {
    trackProductToCartClick,
    trackMiniProductToCartClick,
    trackProductReduceItemCount,
    trackProductToFavoritesAdd,
    trackProductToFavoritesDelete,
    trackProductView,
  };
}
